export default __webpack_public_path__ + "static/media/twitter-icon.29c3818e.svg";